import React from 'react';
import { PageSection } from '../../../atoms/layout/PageSection';
import { LoaderRow } from '../../../atoms/layout/LoaderRow';
import { EventListPane } from '../../../molecules/events/EventListPane';
import { GlobalStatesV3 } from '../../../../../commonv3/states/GlobalStatesV3';
import { V2Routes } from '../../../../../mainv2/routes';
import { V3Routes } from '../../../../routes';
import { observer } from 'mobx-react';
import { CurrentUserState, FlagKeys } from '../../../../../mainv2/states/CurrentUserState';
import { RemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { SheLocation } from '../../../../types/location';
import { EventListState } from '../../events/states/EventListState';
import { routingStore } from '../../../../../common/stores/routing';

type Props = {
  currentUser: CurrentUserState;
  eventList: EventListState;
  locations: RemoteResourceV3<SheLocation[]>;
};

export const EventSection = observer(({ currentUser, eventList }: Props) => {
  const { filteredEvents, loading } = eventList;
  return (
    <PageSection title="EVENT" subTitle="イベント" background="white" id={'event-list-section'}>
      {loading || (currentUser.loading && <LoaderRow />)}
      <EventListPane
        events={filteredEvents.slice(0, 6)}
        onItemClick={(ev) =>
          GlobalStatesV3.routing.push(
            GlobalStatesV3.currentUser.hasEnabledFlagKey(FlagKeys.REDIRECT_EVENT_DETAIL_PAGE)
              ? V2Routes.eventDetailsPage(ev.id)
              : V3Routes.DynamicPath.openEventOverlay(routingStore.location, ev.id)
          )
        }
      />
    </PageSection>
  );
});
